import type {SagaIterator} from 'redux-saga'
import {fork, takeLatest, call} from 'redux-saga/effects'
import {toast} from 'shared/toaster'
import {actBookingAgencyBookerSaga} from './actBookingAgencyBooker/sagas'
import {departmentSaga} from './department/sagas'
import {organizationSaga} from './organization/sagas'
import {personSaga} from './person/sagas'
import {roleSaga} from './role/sagas'
import {tourSaga} from './tour/sagas'

interface ErrorAction {
  type: string
  originalMessage?: string
  error?: string
}

function* createSuccessToast(): SagaIterator {
  yield call(toast.success, 'Created successfully')
}

function* updateSuccessToast(): SagaIterator {
  yield call(toast.success, 'Updated successfully')
}

function* deleteSuccessToast(): SagaIterator {
  yield call(toast.success, 'Removed successfully')
}

function* createFailureToast(action: ErrorAction): SagaIterator {
  yield call(toast.error, 'Could not create', {
    description: action?.originalMessage ?? action.error,
  })
}

function* updateFailureToast(action: ErrorAction): SagaIterator {
  yield call(toast.error, 'Could not update', {
    description: action?.originalMessage ?? action.error,
  })
}

function* deleteFailureToast(action: ErrorAction): SagaIterator {
  yield call(toast.error, 'Could not remove', {
    description: action?.originalMessage ?? action.error,
  })
}

export function* entitySaga() {
  yield fork(organizationSaga)
  yield fork(departmentSaga)
  yield fork(personSaga)
  yield fork(tourSaga)
  yield fork(roleSaga)
  yield fork(actBookingAgencyBookerSaga)

  yield takeLatest(
    (action: any) => /^Entity\/.*\/CREATE_SUCCESS$/.test(action.type),
    createSuccessToast
  )
  yield takeLatest(
    (action: any) => /^Entity\/.*\/UPDATE_SUCCESS$/.test(action.type),
    updateSuccessToast
  )
  yield takeLatest(
    (action: any) => /^Entity\/.*\/DELETE_SUCCESS$/.test(action.type),
    deleteSuccessToast
  )

  yield takeLatest(
    (action: any) => /^Entity\/.*\/CREATE_FAILURE$/.test(action.type),
    createFailureToast
  )
  yield takeLatest(
    (action: any) => /^Entity\/.*\/UPDATE_FAILURE$/.test(action.type),
    updateFailureToast
  )
  yield takeLatest(
    (action: any) => /^Entity\/.*\/DELETE_FAILURE$/.test(action.type),
    deleteFailureToast
  )
}
